import axios from 'axios';
import mainAPI from './api';

const modelBase = `${process.env.REACT_APP_API_MODELDOMAIN || process.env.REACT_APP_API_DOMAIN || ''}`;

const modelAPI = axios.create({
  baseURL: modelBase,
  withCredentials: true,
});

let tokenPromise = null;

async function getAccessToken() {
  const { data } = await mainAPI.get('/auth/token', { withCredentials: true });
  return data?.access_token ?? null;
}

modelAPI.interceptors.request.use(async (config) => {
  if (!tokenPromise) {
    tokenPromise = getAccessToken().finally(() => {
      tokenPromise = null;
    });
  }
  const token = await tokenPromise;
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

modelAPI.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response || !config || response.status !== 401 || config._retry) throw error;

    tokenPromise = getAccessToken().finally(() => {
      tokenPromise = null;
    });
    const newToken = await tokenPromise;

    config._retry = true;
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${newToken}`;
    return modelAPI.request(config);
  }
);

export default modelAPI;
